import React from 'react';
import { Form } from 'react-bootstrap';

/**
 * NumeroOrdenInput - Input component for OT order number
 * @param {Object} props - Component props
 * @param {string} props.value - Current value of the input
 * @param {Function} props.onChange - Change handler receiving event
 * @returns {JSX.Element}
 */
const NumeroOrdenInput = ({ value, onChange, disabled = false }) => {
    return (
        <Form.Group className="mb-3">
            <Form.Label><strong>Número de Orden *</strong></Form.Label>
            <Form.Control
                type="text"
                value={value}
                onChange={onChange}
                placeholder="Ej: OT-2024-001"
                disabled={disabled}
            />
        </Form.Group>
    );
};

export default NumeroOrdenInput;
